import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Routes from '../../../../../constants/routes';
import { reset } from '../../../../../reducers/cart';

type UseAddToCartSuccessReturn = ({ cart }: { cart: Cart }) => void;

const useAddToCartSuccess = (): UseAddToCartSuccessReturn => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    return ({ cart }: { cart: Cart }): void => {
        dispatch(reset(cart));

        const isCartPage = location.pathname === Routes.WARENKORB.path;

        !isCartPage && navigate(Routes.WARENKORB.path);
    };
};

export default useAddToCartSuccess;
